export const HOLIDAY = "HOLIDAY";
export const HOLIDAY_SUCCESS = "HOLIDAY_SUCCESS";
export const HOLIDAY_FAILED = "HOLIDAY_FAILED";

export const ADD_HOLIDAY = "ADD_HOLIDAY";
export const ADD_HOLIDAY_SUCCESS = "ADD_HOLIDAY_SUCCESS";
export const ADD_HOLIDAY_FAILED = "ADD_HOLIDAY_FAILED";

export const UPDATE_HOLIDAY = "UPDATE_HOLIDAY";
export const UPDATE_HOLIDAY_SUCCESS = "UPDATE_HOLIDAY_SUCCESS";
export const UPDATE_HOLIDAY_FAILED = "UPDATE_HOLIDAY_FAILED";